<script>
    import {onMount} from "svelte";
    import {mainTimeline} from "../../timelines/main-timeline";

    const anConfig = {
        opacity: 0,
        duration: 1
    };

    onMount(() => {
        mainTimeline.from('#tip-0', anConfig, 'pathStart+=1');
        mainTimeline.from('#tip-1', anConfig, 'path0+=0.5');
        mainTimeline.from('#tip-2', anConfig, 'path1+=0.5');
        mainTimeline.to('#tip-0', anConfig, 'path0+=0.1');
        mainTimeline.to('#tip-1', anConfig, 'path1+=0.1');
        mainTimeline.to('#tip-2', anConfig, 'path2+=0.1');
    });

</script>


<svg xmlns="http://www.w3.org/2000/svg" width="300" height="179" viewBox="0 0 300 179" id="tip-0" x="1100" y="870">
    <rect id="Rectangle_764" data-name="Rectangle 764" width="283" height="179" transform="translate(17)"/>
    <path id="Polygon_3" data-name="Polygon 3" d="M14.5,0,29,25H0Z" transform="translate(0 45) rotate(-90)"/>
    <text id="Is_your_content_strategic_enough_" data-name="Is your content strategic enough?"
          transform="translate(31 10)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">Is your content</tspan>
        <tspan x="0" y="47">strategic enough?</tspan>
    </text>
    <text id="_61_of_business_leaders_look_for_topics_that_address_the_board_agenda"
          data-name="61% of business leaders look for topics that address the board agenda" transform="translate(31 71)"
          fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">61% of business leaders</tspan>
        <tspan x="0" y="47">look for topics that address</tspan>
        <tspan x="0" y="71">the board agenda</tspan>
    </text>
</svg>

<svg xmlns="http://www.w3.org/2000/svg" width="302" height="169" id="tip-1" x="490" y="580" viewBox="0 0 302 169">
    <rect id="Rectangle_765" data-name="Rectangle 765" width="286" height="169"/>
    <path id="Polygon_5" data-name="Polygon 5" d="M14.5,0,29,25H0Z" transform="translate(302 16) rotate(90)"/>
    <g id="Group_1661" data-name="Group 1661" transform="translate(-555 -620)">
        <text id="Do_you_understand_our_sector_" data-name="Do you understand
our sector?
" transform="translate(568 626)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
            <tspan x="0" y="23">Do you understand</tspan>
            <tspan x="0" y="47">our sector?</tspan>
        </text>
        <text id="_57_of_business_leaders_want_ideas_that_are_specific_to_their_sector"
              data-name="57% of business leaders want ideas that are specific to their sector"
              transform="translate(568 687)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
            <tspan x="0" y="23">57% of business leaders</tspan>
            <tspan x="0" y="47">want ideas that are specific</tspan>
            <tspan x="0" y="71">to their sector</tspan>
        </text>
    </g>
</svg>


<svg xmlns="http://www.w3.org/2000/svg" width="237" height="269" viewBox="0 0 237 269" y="650" x="1260" id="tip-2">
    <rect id="Rectangle_764" data-name="Rectangle 764" width="220" height="269" transform="translate(17)"/>
    <path id="Polygon_3" data-name="Polygon 3" d="M14.5,0,29,25H0Z" transform="translate(0 45) rotate(-90)"/>
    <text id="Can_you_give_me_actionable_recommendations_" data-name="Can you give me
actionable recommendations?
" transform="translate(31 10)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">Can you give me</tspan>
        <tspan x="0" y="47">actionable</tspan>
        <tspan x="0" y="71">recommendations?</tspan>
        <tspan font-family="Metric-Semibold, Metric" font-weight="600">
            <tspan x="0" y="95"></tspan>
        </tspan>
    </text>
    <text id="_53_of_business_leaders_want_insights_that_help_solve_a_particular_challenge"
          data-name="53% of business leaders want insights that help solve a particular challenge"
          transform="translate(31 94)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">53% of business</tspan>
        <tspan x="0" y="47">leaders want</tspan>
        <tspan x="0" y="71">insights that help</tspan>
        <tspan x="0" y="95">solve a particular</tspan>
        <tspan x="0" y="119">challenge</tspan>
    </text>
</svg>
